var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLusin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3758 6.92792C11.2906 7.84994 10.9446 8.72864 10.3782 9.46118C9.81181 10.1937 9.04852 10.7498 8.17764 11.0644C7.30676 11.3789 6.36429 11.439 5.46053 11.2375C4.55677 11.0359 3.72909 10.5812 3.07434 9.92646C2.41959 9.27171 1.96485 8.44403 1.76333 7.54027C1.56182 6.63651 1.62186 5.69405 1.93643 4.82316C2.25099 3.95228 2.80708 3.18899 3.53962 2.62262C4.27216 2.05624 5.15086 1.71021 6.07288 1.625C5.53307 2.35531 5.2733 3.25512 5.34084 4.16077C5.40838 5.06641 5.79873 5.91774 6.44089 6.55991C7.08306 7.20208 7.93439 7.59242 8.84003 7.65996C9.74568 7.7275 10.6455 7.46773 11.3758 6.92792Z",
    fill: "#BDBDBE",
    stroke: "#BDBDBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLusin);
export default __webpack_public_path__ + "static/media/lusin.3f0b537bfba9240fc8459d42f44dfb8b.svg";
export { ForwardRef as ReactComponent };